<template>
  <v-container
    :pa-3="$vuetify.breakpoint.xsOnly"
  >
    <v-layout
      pa-0
    >
      <v-flex
        class="flex-container"
      >
        <chart
          :chart="chartHourly"
        ></chart>
        <chart
          class="mt-4"
          :chart="chartDaily"
        ></chart>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Chart from '@/components/report/Chart'
  import mixinsPages from '@/mixins/pages'
  import mixinsSearch from '@/mixins/search'

  export default {
    title: 'Reports',
    mixins: [mixinsPages, mixinsSearch],
    data () {
      return {
        chartHourly: {},
        chartDaily: {}
      }
    },
    methods: {
      getSeries (period) {
        return this.$axios.get('report', {
          params: {
            id: this.activeSearch.id,
            period: period
          }
        })
      },
      getChartData (name, data) {
        return {
          name: name,
          series: [{
            name: this.activeSearch.name,
            data: data.data.data
          }],
          categories: data.data.categories
        }
      },
      async getCharts (name) {
        if (this._.isUndefined(this.activeSearch)) {
          return
        }
        this.$store.commit('pages/setTitle', 'Reports - ' + this.activeSearch.name)
        const dataHourly = await this.getSeries('hourly')
        this.chartHourly = this.getChartData('Last 24 hours mentions', dataHourly)
        const dataDaily = await this.getSeries('daily')
        this.chartDaily = this.getChartData('Last month mentions', dataDaily)
      }
    },
    watch: {
      activeSearch () {
        this.getCharts()
      }
    },
    mounted () {
      this.getCharts()
    },
    components: {
      Chart
    }
  }
</script>

<style scoped>
  .flex-container {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/pages/report/report-index.vue